import { Card } from '../ui/Card'
import { cn } from '@/lib/utils'

interface StatCardProps {
  label: string
  value: number | string | undefined
  sub?: string
  warn?: boolean
}

export function StatCard({ label, value, sub, warn }: StatCardProps) {
  const ready = value !== undefined
  return (
    <Card>
      <div className="text-xs font-bold text-text-3 uppercase tracking-[0.06em] mb-[0.4rem]">
        {label}
      </div>
      <div className={cn(
        'text-[2rem] font-bold leading-none',
        ready
          ? (warn && Number(value) > 0 ? 'text-warning-text' : 'text-text-heading')
          : 'text-border-input',
      )}>
        {ready ? value : '—'}
      </div>
      {sub && <div className="text-xs text-text-3 mt-[0.3rem]">{sub}</div>}
    </Card>
  )
}
